<template>
  <vx-card class="mt-base mb-5" title="Certificate">
    <template v-if="postwork.certificate_status == 3">
      <p class="mb-5">
        Your request to approve your Work Experience Certificate was declined on
        {{ postwork.certificate_date_declined }}.
      </p>
      <heading size="h3" style-size="h5" class="mb-5 font-normal"
        ><u>Reason for declining:</u></heading
      >
      <p class="mb-10">{{ postwork.reason_for_declining }}</p>

      <restart-experience-button-wrapper />
    </template>
  </vx-card>
</template>

<script>
import store from '@/store/store';
import state from '@/store/store';
import RestartExperienceButtonWrapper from '@/views/WorkExperiences/components/WorkExperience/RestartExperienceButtonWrapper';
export default {
  components: { RestartExperienceButtonWrapper },
  data() {
    return {
      loginType: localStorage.getItem('login_type'),
    };
  },
  computed: {
    experience() {
      const loginType = this.loginType;
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return state.getters['authTeacher/experience'];
      }
    },
    postwork() {
      if (typeof this.experience.postwork !== 'undefined' && this.experience.postwork != null)
        return this.experience.postwork;
      else return null;
    },
  },
  methods: {},
};
</script>
